import { Provider } from 'mobx-react'
import * as React from 'react'
import { Router } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { stores } from './stores'
import Layout from './components/layout/Layout'
import ScrollToTop from './components/containers/ScrollToTop'

const history = createBrowserHistory()

history.listen((location, _action) => {
  if (process.env.REACT_APP_ENV !== 'development') {
    if (window && window.dataLayer) {
      window.dataLayer.push({
        event: 'pageview',
        page: location.pathname
      })
    }
  }
})

class App extends React.Component {
  public render() {
    return (
      <Router history={history}>
        <ScrollToTop>
          <Provider {...stores}>
            <Layout history={history} />
          </Provider>
        </ScrollToTop>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.tsx